import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useMutation } from 'react-query'
import useEventLogger from '../hooks/useEventLogger'

type DeleteActivityVariables = {
    activityId: string
    roadmapId: string
    activityData?: unknown
}

export const useDeleteActivityMutation = () => {
    const { logEvent, ACTIONS } = useEventLogger()
    const { getTokenSilently } = useAuth0()

    const deleteActivity = async ({ activityId, roadmapId, activityData }: DeleteActivityVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { method } = endpoints.deleteActivity
        const url = `${endpoints.deleteActivity.url}${activityId}/roadmap/${roadmapId}`

        const response = await callAPI(url, method, token)

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to delete activity')
        }

        logEvent(ACTIONS.DELETE, { type: 'Activity', data: activityData })
    }

    return useMutation(deleteActivity)
}
